<div class="tis-login-page">
    <div class="tis-login-container">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="tis-login-header">
                <div class="login-logo">
                    <img alt="logo2" src="assets/logo/cantrak-logo.svg">
                </div>
                <div class="tis-language-selection">
                    <span class="text-sm tis-text-primary">Select Language</span>
                    <ul>
                        <li>
                            <a id="engLang" class="eng_font tis-curser-pointer">
                                <img src="/assets/icons/en.png" alt="" class="mr-2 w-7 h-7 rounded-full">
                            </a>
                        </li>
                        <li>
                            <a id="thLang" class="thai_font tis-curser-pointer">
                                <img src="/assets/icons/th.png" alt="" class="mr-2 w-7 h-7 rounded-full">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tis-login-body">
                <mat-form-field class="tis-mat-form-field" appearance="outline">
                    <mat-label>Email/Mobile/Username</mat-label>
                    <input matInput placeholder="Email/Mobile/Username" formControlName="username">
                    @for (validation of validationMessages.username; track validation.type) {
                        <mat-error *ngIf="loginForm.get('username')?.hasError(validation.type) && (loginForm.get('username')?.dirty || loginForm.get('username')?.touched)">{{validation.message}}</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="tis-mat-form-field" appearance="outline">
                    <mat-label>Password</mat-label>
                    <input [type]="isShowPassword? 'text' : 'password'" matInput placeholder="Enter your password" formControlName="password">
                    <button matSuffix mat-icon-button type="button" (click)="isShowPassword=!isShowPassword">
                        @if(isShowPassword){
                            <mat-icon>visibility</mat-icon>
                        }
                        @if(!isShowPassword){
                            <mat-icon>visibility_off</mat-icon>
                        }
                    </button>
                    @for (validation of validationMessages.password; track validation.type) {
                        <mat-error *ngIf="loginForm.get('password')?.hasError(validation.type) && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)">
                            {{validation.message}}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="tis-login-footer">
                <ul>
                    <li>
                        <a class="tis-a" [routerLink]="['/forget-password']">Forgot Password</a>
                    </li>
                </ul>
                <div class="tis-footer-action">
                    <button mat-flat-button class="tis-btn-filled-primary w-full">
                        Login
                        <i class="fas fa-spinner fa-spin" *ngIf="formLoading"></i>
                    </button>
                    <h2 class="tis-or">
                        <div>OR</div>
                    </h2>
                    <button (click)="attemptLineLogin()" mat-flat-button type="button" class="tis-btn-filled-primary w-full tis-btn-line">
                        <div class="flex items-center">
                            <div class="px-2 mr-2 border-r-slate-50 flex">
                                <img src="assets/icons/line.png" width="25" alt="line">
                            </div>
                            Login With Line
                        </div>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>